import React, { useEffect, useState } from 'react';
import { AGridColDef } from '../../../../common/data-grid/ADataGridColDef';
import ADataGrid from '../../../../common/data-grid/ADataGrid';
import { gridStyles } from '../../../../edpOps/issuanceIDcard/printIdCardAndMapRfid/constant';
import { gridComponents } from '../../../../edpOps/issuanceIDcard/printIdCardAndMapRfid/constant';
import NoRowOverlay from '../../../../masters/holidayMaster/NoRowOverlay';
import { Tooltip } from '@mui/material';
import moment from 'moment';
import { statusMapping, statusMappingStyle } from './constant';
import CustomCopyToClipboard from 'views/pages/manage/common/ACopyToClipboard/CustomCopyToClipboard';


const SapLogsListing = ({
    rows,
    loader
}) => {


    const getFormatedDate = (date, timeRequired) => timeRequired ? moment(date)?.format("DD/MM/YYYY hh:mm A") : moment(date)?.format("DD/MM/YYYY")

    const columns = [

        new AGridColDef('srNo', 'Sr No.', false)
            .setMinWidth(50)
            .setFlex(0.2)
            .editable(true)
            .setValueGetter(params => params?.value),

        new AGridColDef('systemName', 'Mapping', false)
            .setMinWidth(100)
            .setFlex(0.8)
            .editable(true)
            .renderCellComponent((params) =>
                params?.value ? (
                    <Tooltip title={params?.value}>
                        <div className="ellipsis-text-container">
                            {params?.value}
                        </div>
                    </Tooltip>
                ) : (
                    <div className="m-auto">-</div>
                )
            ),

        new AGridColDef('externalId', 'ID', false)
            .setMinWidth(110)
            .setFlex(1)
            .editable(true)
            .renderCellComponent((params) =>
                params?.value ? (
                    <div className='d-flex ellipsis-text-container'>
                        <Tooltip title={params?.value}>
                            <div className='ellipsis-text-container'>
                                {params?.value}
                            </div>
                        </Tooltip>
                        <CustomCopyToClipboard textToCopy={params?.value} />
                    </div>
                ) : (
                    <div className="m-auto">-</div>
                )
            ),
        new AGridColDef('status', 'Status', false)
            .setMinWidth(80)
            .setFlex(0.5)
            .editable(true)
            .renderCellComponent((params) =>
                params?.value ? (
                    <Tooltip title={statusMapping?.[(params?.value).toUpperCase()]}>
                        <div className="ellipsis-text-container" style={statusMappingStyle?.[(params?.value).toUpperCase()]}>
                            {statusMapping?.[(params?.value).toUpperCase()]}
                        </div>
                    </Tooltip>
                ) : (
                    <div className="m-auto">-</div>
                )
            ),

        new AGridColDef('createdOn', 'Created On', false)
            .setMinWidth(100)
            .setFlex(1)
            .editable(true)
            .renderCellComponent((params) =>
                params?.value && params?.row?.status != 'NOTMAPPED' ? (
                    <Tooltip title={`${moment(params?.value).format('DD MMM YYYY')}, ${moment(params?.value).format('hh:mm A')}`}>
                        <div className="ellipsis-text-container">
                            {`${moment(params?.value).format('DD MMM YYYY')}, ${moment(params?.value).format('hh:mm A')}`}
                        </div>
                    </Tooltip>
                ) : (
                    <div className="m-auto">-</div>
                )
            ),

        new AGridColDef('updatedOn', 'Last Updated On', false)
            .setMinWidth(150)
            .setFlex(1.2)
            .editable(true)
            .renderCellComponent((params) =>
                params?.value && params?.row?.status != 'NOTMAPPED' ? (
                    <Tooltip title={`${moment(params?.value).format('hh:mm A')}, ${moment(params?.value).format('DD MMM YYYY')} by ${params?.row?.updatedBy}`}>
                        <div className="ellipsis-text-container">
                            {`${moment(params?.value).format('hh:mm A')}, ${moment(params?.value).format('DD MMM YYYY')} by ${params?.row?.updatedBy}`}
                        </div>
                    </Tooltip>
                ) : (
                    <div className="m-auto">-</div>
                )
            )
    ]

    return (

        <ADataGrid
            removeWrapperContainer
            rows={rows || []}
            columns={columns}
            rowId={(row) => JSON.stringify(row)}
            rowHeight={50}
            loading={false}
            components={{
                ...gridComponents,
                NoRowsOverlay: () => (
                    <NoRowOverlay message={loader ? "Loading..." : null} />
                ),
            }}
            sx={gridStyles}
            autoHeight
            hidePagination
            serverPagination={false}
        />

    );
}

export default SapLogsListing;